import React, { FC, useCallback, useEffect, useReducer, useState } from 'react';

import { Box, HStack, Radio, RadioGroup } from '@chakra-ui/react';
import { find } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { SelectHistoricalOptions } from 'components/DataEntry';
import { OptionItem } from 'components/DataEntry/Button/types';
import { VulnerabilityFiltersMenu } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/Vulnerability/VulnerabilityFiltersMenu';
import { VulnerabilityTabActions } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/Vulnerability/VulnerabilityTabActions';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { actions } from 'containers/ActiveCloudResource/slice';
import { vulnerabilityButtonGroupOptions } from 'containers/ActiveCloudResource/utils';
import {
  patchAvailableOptions,
  vulnerabilitySeverityOptions,
} from 'containers/Visibility/Vulnerabilities/Components/utils';

export const VulnerabilityTabFilters: FC = () => {
  const {
    vulnerabilityPublishedTime,
    showResolvedVulnerabilities,
    vulnerabilitySeverity,
    isPatchable,
    vulnerabilitySummary,
  } = useSelector(selectActiveResource);
  const dispatch = useDispatch();
  const [showResolved, setShowResolved] = useState<OptionItem>(
    vulnerabilityButtonGroupOptions[0],
  );

  const [state, updateState] = useReducer(
    (prev, next) => {
      return { ...prev, ...next };
    },
    {
      isPatchable: patchAvailableOptions[0],
      severity: vulnerabilitySeverityOptions[0],
    },
  );

  useEffect(() => {
    updateState({
      isPatchable: find(patchAvailableOptions, o => o.value === isPatchable),
    });
  }, [isPatchable]);

  useEffect(() => {
    updateState({
      severity: find(
        vulnerabilitySeverityOptions,
        o => o.value === vulnerabilitySeverity,
      ),
    });
  }, [vulnerabilitySeverity]);

  useEffect(() => {
    if (showResolvedVulnerabilities)
      setShowResolved(vulnerabilityButtonGroupOptions[1]);
    else setShowResolved(vulnerabilityButtonGroupOptions[0]);
  }, [showResolvedVulnerabilities]);

  const renderHistoricalOptions = () => (
    <Box>
      <SelectHistoricalOptions
        historicalTime={vulnerabilityPublishedTime}
        setHistoricalTime={s =>
          dispatch(actions.updateVulnerabilityPublishedAt(s))
        }
        leftMessage={
          showResolved?.key === 'resolved' ? 'Resolved' : 'Published'
        }
        isAFilter
        showIsLAbel={false}
      />
    </Box>
  );

  const updateValue = useCallback(
    (field, value) => {
      switch (field) {
        case 'severity':
          dispatch(actions.updateVulnerabilitySeverity(value?.value));
          break;
        case 'isPatchable':
          dispatch(actions.updateIsPatchable(value?.value));
          break;
      }
    },
    [dispatch],
  );

  return (
    <BorderedBox>
      <HStack justify="space-between">
        <HStack spacing={4}>
          <HStack>
            <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
            <VulnerabilityFiltersMenu
              isLoading={vulnerabilitySummary.isLoading}
              isPatchable={state.isPatchable}
              severity={state.severity}
              updateValue={updateValue}
              showPackageType={false}
              showExploitable={false}
            />
            {renderHistoricalOptions()}
          </HStack>
          <HStack>
            <FilterLabelWrapper>LIST</FilterLabelWrapper>
            <RadioGroup
              value={showResolved?.key}
              onChange={s =>
                dispatch(
                  actions.updateShowResolvedVulnerabilities(s === 'resolved'),
                )
              }
            >
              <HStack>
                <Radio value="open">Open</Radio>
                <Radio value="resolved">Resolved</Radio>
              </HStack>
            </RadioGroup>
          </HStack>
        </HStack>
        <VulnerabilityTabActions />
      </HStack>
    </BorderedBox>
  );
};
